// extracted by mini-css-extract-plugin
export default {"orangeLink":"Account_orangeLink__yvBuF"};